/* eslint-disable */
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import { PageHeader } from "@shared/components/PageHeader";
import React from "react";
import { useGetConnectorsCatalog } from "../../../hooks";

const ErpIntegrationLanding = () => {
  const { data: erpData } = useGetConnectorsCatalog("erp");

  const cards: IntegrationCardConfig[] =
    erpData?.results?.map((item: any) => {
      const connectorKey = item.connectorKey;
      const displayName = item.displayName;
      const category = item.category;
      const description = item.description;
      const isFeatured = item.isFeatured;
      const connectionId = item.connectionId;
      const status = item.status;
      const initials = item.initials;
      const color = item.color;

      const isAclarian =
        connectorKey?.toLowerCase() === "aclarian" ||
        displayName?.toLowerCase()?.includes("aclarian") ||
        item.key?.toLowerCase() === "aclarian" ||
        item.connector_key?.toLowerCase() === "aclarian";

      const comingSoon = isAclarian ? false : true;

      return {
        title: displayName,
        subtitle: category,
        description: description,
        status: status,
        featured: isFeatured,
        initials: initials,
        color: color,
        comingSoon: comingSoon,
        connectPath: `/erp-integration/${connectorKey}/create`,
        configurePath: `/erp-integration/${connectorKey}/configure/${connectionId}`,
        detailsPath: `/erp-integration/${connectorKey}/view/${connectionId}`,
        primaryLabelNotConnected: "Create",
      };
    }) || [];

  return (
    <div className="space-y-6">
      <PageHeader
        title="ERP Integration"
        subtitle="Manage ERP connectors for billing, customer sync, finance workflows, and operational data exchange."
      />
      <IntegrationCardGrid cards={cards} />
    </div>
  );
};

export default ErpIntegrationLanding;
